import React, { useEffect, useState } from 'react';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { arrayOf, string } from 'prop-types';
import classNames from 'classnames';
import { Avatar, Modal, ReviewRating, UserDisplayName } from '../../components';
import { propTypes } from '../../util/types';
import { isArrayLength } from '../../util/genericHelpers';

import css from './Reviews.module.css';

const Review = props => {
  const { review, intl, onManageDisableScrolling } = props;

  const date = review.attributes.createdAt ? new Date(review.attributes.createdAt) : new Date();
  const images = review?.images || review?.photos?.map(photo => photo.url).filter(Boolean);
  const dateString = intl.formatDate(date, { month: 'long', year: 'numeric' });

  const [tosModalOpen, setTosModalOpen] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [tosModalOpen]);
  return (
    <>
      <div className={css.review}>
        <div className={css.reviewerSec}>
          <Avatar className={css.avatar} user={review.author} />
          <div className={css.reviewerHead}>
            <UserDisplayName className={css.userName} user={review.author} intl={intl} />
            {/* <p>Bucharest, Romania</p> */}
          </div>
        </div>
        <div className={css.reviewContentSec}>
          <div className={css.reviewInfo}>
            <span className={css.desktopReviewRatingWrapper}>
              <ReviewRating
                rating={review.attributes.rating}
                className={css.desktopReviewRating}
                reviewStarClassName={css.reviewRatingStar}
              />
            </span>
            {'·'}
            <span>{dateString}</span>
          </div>
          <p className={css.reviewContent}>{review.attributes.content}</p>
          {isArrayLength(images) ? (
            <>
              <div className={css.inlineImagesReviews}>
                {images.slice(0, 4).map(i => (
                  <button
                    key={i}
                    type="button"
                    className={css.inlineImgThumb}
                    onClick={() => setTosModalOpen(true)}
                  >
                    <img src={i} alt="Review" />
                  </button>
                ))}
              </div>
              <span className={css.showMoreLink} onClick={() => setTosModalOpen(true)}>
                Show more
              </span>
            </>
          ) : null}
        </div>
      </div>
      <Modal
        id="AuthenticationPage.tos"
        isOpen={tosModalOpen}
        onClose={() => setTosModalOpen(false)}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <div className={css.review}>
          <div className={css.reviewerSec}>
            <Avatar className={css.avatar} user={review.author} />
            <div className={css.reviewerHead}>
              <UserDisplayName className={css.userName} user={review.author} intl={intl} />
              {/* <p>Bucharest, Romania</p> */}
            </div>
          </div>
          <div className={css.reviewContentSec}>
            <div className={css.reviewInfo}>
              <span className={css.desktopReviewRatingWrapper}>
                <ReviewRating
                  rating={review.attributes.rating}
                  className={css.desktopReviewRating}
                  reviewStarClassName={css.reviewRatingStar}
                />
              </span>
              {'·'}
              <span>{dateString}</span>
            </div>
            <p className={classNames(css.reviewContent, css.modalReviewContent)}>
              {review.attributes.content}
            </p>
            {isArrayLength(images) ? (
              <div className={css.imagesReviews}>
                {images.map(i => (
                  <div className={css.imgThumb}>
                    <img src={i} alt="Reviews" />
                  </div>
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </Modal>
    </>
  );
};

Review.propTypes = {
  review: propTypes.review.isRequired,
  intl: intlShape.isRequired,
};

const ReviewsComponent = props => {
  const { className, rootClassName, reviews, intl, onManageDisableScrolling } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <ul className={classes}>
      {reviews.map(r => {
        const reviewId = r?.id?.uuid || r?.id;
        return (
          <li key={`Review_${reviewId}`} className={css.reviewItem}>
            <Review onManageDisableScrolling={onManageDisableScrolling} review={r} intl={intl} />
          </li>
        );
      })}
    </ul>
  );
};

ReviewsComponent.defaultProps = {
  className: null,
  rootClassName: null,
  reviews: [],
};

ReviewsComponent.propTypes = {
  className: string,
  rootCalssName: string,
  reviews: arrayOf(propTypes.review),

  // from injectIntl
  intl: intlShape.isRequired,
};
const Reviews = injectIntl(ReviewsComponent);

export default Reviews;
